import React from 'react';
import { Modal } from 'react-responsive-modal';

const KeyPressModal = ({ open, onClose, keysData }) => {
  console.log('keysData', keysData);
  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      classNames={{ modal: 'custom-modal' }}
    >
      <div className="d-flex justify-content-between align-items-center p-2">
        <h6>Keys Pressed</h6>
        <i
          onClick={onClose}
          className="fa fa-times font-20"
          style={{ cursor: 'pointer' }}
        ></i>
      </div>
      <div className="p-2 press_box">
        <span>{keysData}</span>
      </div>
      <div className="modal-footer d-flex justify-content-end align-items-center mt-2">
        <button type="button" className="btn btn-primary" onClick={onClose}>
          Close
        </button>
      </div>
    </Modal>
  );
};

export default KeyPressModal;
